<div class="fixed-header" [style.top]="topOffset" [style.left]="sidenavWidth">
  <div class="flex-row header-content">
    <div class="flex-row">
      <ng-content select=".additional-actions"></ng-content>
    </div>
    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <div class="flex-row">
      @if (showBack) {
        <button mat-stroked-button (click)="back.emit()" color="primary">
          {{ 'Contacts.Management.Actions.Back' | translate: locale.language }}
        </button>
      } @else {
        <button mat-stroked-button (click)="cancel.emit()" color="warn">
          {{ 'Contacts.Management.Actions.Cancel' | translate: locale.language }}
        </button>
      }
      @if (showSave) {
        <button [disabled]="!isValid || isLoading" mat-stroked-button (click)="save.emit()" color="primary">
          {{ 'Contacts.Management.Actions.Save' | translate: locale.language }}
        </button>
      }
    </div>
  </div>
</div>
